import { getBaseApi } from "../BaseApi";
import { buildUrl } from "../utils";

export function getTransferOrders(params: {
  limit: number;
  skip: number;
  status?: string;
  country?: string;
  agent?: string;
  keyword?: string;
}) {
  return getBaseApi().get(buildUrl("transfer-orders", params));
}

export function getTransferOrdersSummary(params?: {
  country?: string;
  agent?: string;
}) {
  return getBaseApi().get(buildUrl("transfer-orders/summary", params || {}));
}

export function createTransferOrderApi(data: {
  customerName: string;
  customerPhone: string;
  customerAddress: string;
  product: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  advanceAmount: number;
  transporterName?: string;
  transporterPhone?: string;
  notes?: string;
  country: string;
}) {
  return getBaseApi().post("transfer-orders", data);
}

export function getTransferOrder(id: string) {
  return getBaseApi().get(`transfer-orders/${id}`);
}

export function updateTransferOrderApi(id: string, data: any) {
  return getBaseApi().put(`transfer-orders/${id}`, data);
}

export function updateStatusTransferOrderApi(
  id: string,
  data: {
    status: string;
    advanceProofUrl?: string;
    paidAdvance?: number;
    trackingNumber?: string;
    notes?: string;
  }
) {
  return getBaseApi().put(`transfer-orders/${id}/status`, data);
}

export function deleteTransferOrderApi(id: string) {
  return getBaseApi().delete(`transfer-orders/${id}`);
}
